import { Stack } from "@chakra-ui/react"

export default function Form({ children, onSubmit = () => {}, submitRef, ...props }){

    const handleSubmit = e => {
        e.preventDefault()
        onSubmit()
    }
    
    return(
    <Stack as="form" method="post" spacing={4} h="auto" w="100%" autoComplete="off" onSubmit={handleSubmit} {...props}>
        {children}
        <input type="submit" style={{ display: 'none' }} ref={submitRef} />
    </Stack>
    )
}